import { render, staticRenderFns } from "./deanSectionDivider.vue?vue&type=template&id=66bc4b45&scoped=true"
import script from "./deanSectionDivider.vue?vue&type=script&lang=ts"
export * from "./deanSectionDivider.vue?vue&type=script&lang=ts"
import style0 from "./deanSectionDivider.vue?vue&type=style&index=0&id=66bc4b45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bc4b45",
  null
  
)

export default component.exports